import { render, staticRenderFns } from "./BodyNestedProprty.vue?vue&type=template&id=75c70dcd&scoped=true&"
import script from "./BodyNestedProprty.vue?vue&type=script&lang=js&"
export * from "./BodyNestedProprty.vue?vue&type=script&lang=js&"
import style0 from "./BodyNestedProprty.vue?vue&type=style&index=0&id=75c70dcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c70dcd",
  null
  
)

export default component.exports